import { FadeIn } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const ValueStrip = () => {
  const { t } = useLang();
  const VALUE_STRIP = t.valueStrip;
  return (
  <section id="vrijednosti" data-testid="value-strip" className="bg-krug-navy py-14 md:py-16">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {VALUE_STRIP.map((item, i) => (
        <FadeIn key={item.label} delay={i * 0.08}>
          <div
            data-testid={`value-item-${i}`}
            className="group flex items-center gap-4 rounded-2xl glass-dark px-5 py-5 hover:border-krug-tealbright/40 transition-colors duration-300"
          >
            <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-krug-teal/15 text-krug-tealbright group-hover:bg-krug-teal/25 transition-colors duration-300 shrink-0">
              <item.icon size={20} />
            </span>
            <span className="font-heading font-bold text-sm md:text-base text-white leading-snug">{item.label}</span>
          </div>
        </FadeIn>
      ))}
    </div>
  </section>
  );
};
